import {
  StatusEventSignalValueParsingType
} from '@constants/machine/status-event-signal/status-event-signal-value-parsing-type.enum';
import {StatusEventDetails} from '@models/machine/status-event-signal/status-event-details';

export class StatusEventSignalEventsDetails {
  id: number;
  name: string;
  label: string;
  unit: string;
  parsingType: StatusEventSignalValueParsingType;
  definitions: Map<string, StatusEventDetails>;
  machineId: number;
  csvMappingDisabled: boolean = false;


  constructor(id: number, name: string, label: string, unit: string, parsingType: StatusEventSignalValueParsingType,
              definitions: Map<string, StatusEventDetails>, machineId: number) {
    this.id = id;
    this.name = name;
    this.label = label;
    this.unit = unit;
    this.parsingType = parsingType;
    this.definitions = definitions;
    this.machineId = machineId;
  }
}